var render = function render(){var _vm=this,_c=_vm._self._c;return _c('permit-to-work',{attrs:{"site-id":_vm.site.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }